import React, { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import PageHeaders from "../components/Headers/PageHeaders/PageHeaders";
import { supeabaseClient } from "../config/supeabaseClient";
import { Helmet } from "react-helmet";

const Career = () => {
  const [openingData, setOpeningData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOpenings = async () => {
      try {
        const { data, error } = await supeabaseClient
          .from("openings")
          .select("*");

        if (error) {
          setError("Failed to load openings.");
          console.error("Supabase error:", error);
        } else {
          setOpeningData(data);
        }
      } catch (err) {
        setError("Unexpected error occurred while fetching data.");
        console.error("Unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOpenings();
  }, []);

  console.log(openingData);

  if (loading) {
    return (
<div className="container mx-auto text-center text-white">
          <h2>Loading Open Positions...</h2>
        </div>
    );
  }

  if (error) {
    return (
<div className="container mx-auto text-center text-danger">
          <h2>{error}</h2>
        </div>
    );
  }

  return (
    <div className="container mx-auto">
      <Helmet>
         <title>Career | Netario Innovations</title>
         <meta name="discription" content="Shape your career with us, Explore great opportunities that release your potential, and grow with a team that values creativity, and success. Join us today." />
        <meta name="keywords" content="Career" />
        <link rel="canonical" href="https://netarioinnovations.com/Career" />
        
        <meta property="og:title" content="Shape your career with us" />
        <meta property="og:site_name" content="Netario Innovatives Pvt Ltd" />
        <meta property="og:url" content="https://netarioinnovations.com/Career" />
        <meta property="og:description" content="Shape your career with us, Explore great opportunities that release your potential, and grow with a team that values creativity, and success. Join us today." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://lh3.googleusercontent.com/geougc/AF1QipNWjYsz9DM1V5zlqDwMVyleCQmYMNWx9Dq8cU24=h305-no" />
      
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:domain" content="www.netarioinnovations.com" />
        <meta name="twitter:url" content="https://netarioinnovations.com/Career" />
        <meta name="twitter:title" content="Shape your career with us" />
        <meta name="twitter:description" content="Shape your career with us, Explore great opportunities that release your potential, and grow with a team that values creativity, and success. Join us today." /> 
        <meta name="twitter:image" content="https://lh3.googleusercontent.com/geougc/AF1QipNWjYsz9DM1V5zlqDwMVyleCQmYMNWx9Dq8cU24=h305-no" />
       </Helmet>
    <PageHeaders
      title={"Shape Your Career With Us"}
      message={
        "At Netario IT, we are a growing startup looking for talented people to join our team. We work on exciting projects and help businesses succeed online. If you're passionate about technology and want to be part of a friendly team, we would love to hear from you."
      }
    />
    <div>
      <h2 className="text-center mb-5 text-white">Open Positions</h2>
      <div className="container mx-auto row justify-content-evenly gap-3 px-3">
        {openingData.map((data) => (
          <div
            key={data.id} style={{backgroundColor : "var(--grayBoxPrimary)"}}
            className="col-12 col-md-5 d-flex align-items-center text-white justify-content-between py-2 px-3 fw-bold rounded-4"
          >
            <div>
              <h6 className="fs-5">{data.Name}</h6>
              <div className="d-flex align-items-center gap-3">
                <p className="my-0">
                  <b >Time : </b>
                  {data.time}
                </p>
                <p className="my-0">
                  <b >Duration : </b> {data.duration}
                </p>
                <p className="my-0">
                  <b >Exp : </b> {data.exp}
                </p>
              </div>
            </div>
            {data.opening ? (
              <a
                className="btn btn-success border-0 text-black fw-bold p-1 px-3 mx-1 rounded-5"
                target="_blank"
                rel="noopener noreferrer"
                href={data.link}
              >
                Test
              </a>
            ) : (
              <button
                disabled
                className="btn btn-success border-0 text-black fw-bold p-1 px-3 rounded-5"
              >
                Closed
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Career;
